import { useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { BOARD_CODE } from "../../../constants";
import { useBoardItem } from "../../../hooks/useBoardItem";

const Banner02 = () => {
  const { useGetBoardItems } = useBoardItem();

  const tabs1 = [
    {
      id: 1,
      to: "/News/Notice",
      boardCode: "",
      title: "전체",
    },
    {
      id: 2,
      to: "/News/Notice",
      boardCode: BOARD_CODE.NOTICE,
      title: "공지사항",
    },
    {
      id: 3,
      to: "/News/AnnualReport",
      boardCode: BOARD_CODE.ANNUAL_REPORT,
      title: "연차보고서",
    },
  ];

  const newsBoardCodes = [BOARD_CODE.NOTICE, BOARD_CODE.ANNUAL_REPORT].join(
    ","
  );

  const tabs2 = [
    {
      id: 1,
      to: "/Family/ForKid",
      boardCode: "",
      title: "전체",
    },
    {
      id: 2,
      to: "/Family/ForKid",
      boardCode: BOARD_CODE.BABY_CHEER,
      title: "우리아기 화이팅",
    },
    {
      id: 3,
      to: "/Family/ForDoctor",
      boardCode: BOARD_CODE.CARE_CHEER,
      title: "힘내세요 선생님",
    },
  ];

  const familyBoardCodes = [BOARD_CODE.BABY_CHEER, BOARD_CODE.CARE_CHEER].join(
    ","
  );

  const [tab1, setTab1] = useState(tabs1[0]);
  const [tab2, setTab2] = useState(tabs2[0]);

  const { data: dataNews } = useGetBoardItems(
    {
      page: 1,
      size: 3,
      sort: "createdDate,Desc",
      boardCode: tab1?.boardCode,
      boardCodeIn: !tab1.boardCode ? newsBoardCodes : "",
    },
    (data) => data.data
  );

  const { data: dataFamily } = useGetBoardItems(
    {
      page: 1,
      size: 3,
      sort: "createdDate,Desc",
      boardCode: tab2?.boardCode,
      boardCodeIn: !tab2.boardCode ? familyBoardCodes : "",
    },
    (data) => data.data
  );

  return (
    <>
      <div className="tab_wrap">
        <h2>K-CDH NEWS</h2>
        <div className="tab">
          <ul className="tabnav">
            {tabs1.map((tab) => (
              <li key={tab.id}>
                <span
                  className={`cursor-pointer ${tab.id === tab1.id && "active"}`}
                  onClick={() => setTab1(tab)}
                >
                  {tab.title}
                </span>
              </li>
            ))}
          </ul>
          <div className="tabcontent">
            <div id="tab01-1" className="list">
              <Link className="link" to={tab1.to}>
                <img src="/assets/img/main_btn.png" alt="" />
              </Link>
              {dataNews?.content?.length > 0 ? (
                <div className="h-[119px]">
                  {dataNews.content.map((item) => (
                    <dl key={item.itemNo}>
                      <dt>{item.board.title}</dt>
                      <dd>
                        <Link
                          className="overflow-hidden text-ellipsis line-clamp-1"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            wordBreak: "break-all",
                          }}
                          to={
                            item.board.boardCode === BOARD_CODE.ANNUAL_REPORT
                              ? `/News/AnnualReport`
                              : `${tab1.to}/${item.itemNo}`
                          }
                          title={item.title}
                        >
                          {item.title}
                        </Link>
                        <p>{dayjs(item.createdDate).format("YYYY-MM-DD")}</p>
                      </dd>
                    </dl>
                  ))}
                </div>
              ) : (
                <div className="h-[119px] flex items-center justify-center">
                  <p className="text-gray-dark">등록된 게시글이 없습니다.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="tab_wrap tab_wrap2">
        <h2>K-CDH FAMILY</h2>
        <div className="tab">
          <ul className="tabnav">
            {tabs2.map((tab) => (
              <li key={tab.id}>
                <span
                  className={`cursor-pointer ${tab.id === tab2.id && "active"}`}
                  onClick={() => setTab2(tab)}
                >
                  {tab.title}
                </span>
              </li>
            ))}
          </ul>
          <div className="tabcontent">
            <div id="tab01-2" className="list">
              <Link className="link" to={tab2.to}>
                <img src="/assets/img/main_btn.png" alt="" />
              </Link>
              {dataFamily?.content?.length > 0 ? (
                <div className="h-[119px]">
                  {dataFamily.content.map((item) => (
                    <dl key={item.itemNo}>
                      <dt>{item.board.title}</dt>
                      <dd>
                        <Link
                          className="overflow-hidden text-ellipsis line-clamp-1"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            wordBreak: "break-all",
                          }}
                          to={
                            !tab2?.boardCode
                              ? `${
                                  tabs2.find(
                                    (c) => c.boardCode === item.board.boardCode
                                  )?.to
                                }/${item.itemNo}`
                              : `${tab2.to}/${item.itemNo}`
                          }
                          title={item.title}
                        >
                          {item.title}
                        </Link>
                        <p>{dayjs(item.createdDate).format("YYYY-MM-DD")}</p>
                      </dd>
                    </dl>
                  ))}
                </div>
              ) : (
                <div className="h-[119px] flex items-center justify-center">
                  <p className="text-gray-dark">등록된 게시글이 없습니다.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner02;
